import React from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
    margin-top: 6px;
    margin-right: 20px;
    width: 34px;
    height: 34px;
    background: black;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
`

const Wrapper = styled.div`
    &:not(:last-child) {
        margin-bottom: 40px;
    }

    p {
        margin: 0px;
        color: ${({ theme }) => theme.palette.greyScale.grey};
    }
`

export default ({ children, icon: Icon, className = '' }) => (
    <Wrapper className={className}>
        <div className="grid-x">
            <div className="cell shrink">
                <IconWrapper>
                    <Icon />
                </IconWrapper>
            </div>
            <div className="cell auto">{children}</div>
        </div>
    </Wrapper>
)
